import React from 'react';

interface CertificateExpiringIconProps {
  width?: number;
  height?: number;
  className?: string;
  color?: string;
}

export const CertificateExpiringIcon: React.FC<CertificateExpiringIconProps> = ({
  width = 20,
  height = 20,
  className = '',
  color = '#FF8C00',
}) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      aria-label="受給者証期限間近"
    >
      <g clipPath="url(#clip0_853_14663)">
        <path
          d="M10.0004 13.9497C9.3448 13.9497 8.8125 14.4815 8.8125 15.1371C8.8125 15.793 9.3448 16.3248 10.0004 16.3248C10.6561 16.3248 11.1878 15.793 11.1878 15.1371C11.1879 14.4815 10.6561 13.9497 10.0004 13.9497Z"
          fill={color}
        />
        <path
          d="M19.7304 15.9031L11.7488 2.0785C11.3893 1.45568 10.7193 1.06885 9.9997 1.06885C9.28067 1.06885 8.61126 1.45572 8.25177 2.0785L0.269619 15.9025C-0.089873 16.5253 -0.089873 17.299 0.269619 17.9218C0.62915 18.5446 1.29915 18.9312 2.01817 18.9312H17.9818C18.7008 18.9312 19.3709 18.5446 19.7304 17.9218C20.0899 17.299 20.0899 16.5253 19.7304 15.9031ZM18.1432 16.8908C18.0279 17.0902 17.8133 17.2137 17.5826 17.2137H2.41712C2.18696 17.2137 1.97204 17.0902 1.85739 16.8903C1.74161 16.6906 1.74103 16.4432 1.85685 16.2438L9.43974 3.10947C9.5547 2.91014 9.76927 2.78627 10.0003 2.78627C10.2308 2.78627 10.445 2.91014 10.5603 3.10979L18.1432 16.2436C18.2584 16.4432 18.2584 16.6912 18.1432 16.8908Z"
          fill={color}
        />
        <path
          d="M10.0004 5.96558C9.3448 5.96558 8.8125 6.49733 8.8125 7.15327L9.26875 12.5239C9.26875 12.928 9.59602 13.2553 10.0004 13.2553C10.4043 13.2553 10.7321 12.928 10.7321 12.5239L11.1878 7.15327C11.1879 6.49729 10.6561 5.96558 10.0004 5.96558Z"
          fill={color}
        />
      </g>
      <defs>
        <clipPath id="clip0_853_14663">
          <rect
            width="20"
            height="20"
            fill="white"
          />
        </clipPath>
      </defs>
    </svg>
  );
};

export default CertificateExpiringIcon;
